import { type ProductListing } from '@/types/api/product';
import { MAIN_CATEGORIES_ID, PRICE_INTERNAL_NAMES } from '@/utilities/constants';
import { formatBreadcrumbs } from '@/utilities/formatBreadcrumbs';
import { getCategories } from '@/utilities/getCategories';
import { getCategoryChips } from '@/utilities/getCategoryChips';
import { isValidPriceFilter } from '@/utilities/isValidPriceFilter';

// Moved transforming generic data from the ProductList to a separate selector, following https://tkdodo.eu/blog/react-query-data-transformations pattern.
export const formatListerData = (data: ProductListing) => ({
  ...data,
  navigation: {
    ...data.navigation,
    filters: data.navigation.filters.filter(
      ({ internalName, layoutProperties, visible }) =>
        visible &&
        internalName !== MAIN_CATEGORIES_ID &&
        // Only include price filters if they have a slider or valid min/max range defined
        isValidPriceFilter(layoutProperties) &&
        // TODO: Remove once AEM migration is done: https://bijenkorf.atlassian.net/browse/WD-51012
        !(PRICE_INTERNAL_NAMES.includes(internalName) && !layoutProperties.slider),
    ),
    breadcrumbs: formatBreadcrumbs(data.navigation?.breadcrumbs),
  },
  categories: getCategories(data.navigation.filters),
  categoryChips: getCategoryChips(data.navigation.filters),
});
